/**
 * @author harish.r <harish.r@314ecorp.com>
 * @description React Hook updating verification session
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from 'utils/appEvents';
import { invalidateMetadata } from 'app-constants/queryKeys';

const useUpdateVerificationSession = (): UseMutationResult<Record<string, any>, IAxiosError, { providerId: string }, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ providerId }) => {
			const { data } = await api.EKYCServiceApi.updateIdentificationSession(providerId);
			return data;
		},
		onSuccess: () => {
			invalidateMetadata(queryClient);
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useUpdateVerificationSession;
